<div
  class="wrapper"
  [ngStyle]="{ gap: styles_.gap }"
  (click)="action ? action() : null"
>
  <div
    class="avatar"
    [ngStyle]="this.boxstyle"
    [ngClass]="{ round: this.round, square: !this.round }"
  >
    <ng-content></ng-content>
  </div>
  <div class="details w-full overflow-hidden ">
    <span class="title truncate capitalize" [ngStyle]="this.titleStyle">{{ title }}</span>
    <span
      *ngIf="this.label && this.label !== ''"
      class="label truncate"
      [ngStyle]="this.labelStyle"
      >{{ label }}</span
    >
  </div>
</div>

